import moment from 'moment'
import { FormattedMessage } from 'react-intl.macro'
import React from 'react'

const pathIconHotel = '@assets/img/icons/hotel-detail/'

export const popularDestinations = [
  {
    id: 3,
    backgroundImageUrl: require('@assets/img/bg/dist/diem-den-pho-bien-01.png').default,
    // title: 'Nha Trang',
    title: <FormattedMessage
              id="Experience.VinWonder.SiteInfo.NHATRANG.location"
              defaultMessage='Nha Trang'
            />,
    linkpost: '/tours-and-experiences/search?location=8e4994a7-3e56-401d-8445-1f8ed7a734f0'
  },
  {
    id: 1,
    backgroundImageUrl: require('@assets/img/bg/dist/diem-den-pho-bien.png').default,
    // title: 'Đà Nẵng',
    title: <FormattedMessage
              id="Experience.VinWonder.SiteInfo.DANANG.location"
              defaultMessage='Đà Nẵng'
            />,
    linkpost: '/tours-and-experiences/search?location=1ed61b7c-55d2-48b7-af7d-638cd8738b51'
  },
  {
    id: 2,
    backgroundImageUrl: require('@assets/img/bg/dist/diem-den-pho-bien-02.png').default,
    // title: 'Phú Quốc',
    title: <FormattedMessage
              id="Experience.VinWonder.SiteInfo.PHUQUOCSAF.location"
              defaultMessage='Phú Quốc'
            />,
    linkpost: '/tours-and-experiences/search?location=73f885fa-39cf-409a-b4df-153298656371'
  },

  {
    id: 4,
    backgroundImageUrl: require('@assets/img/bg/dist/diem-den-pho-bien.png').default,
    // title: 'Hội An',
    title: <FormattedMessage
              id="Experience.VinWonder.SiteInfo.NAMHOIAN.location"
              defaultMessage='Phú Quốc'
            />,
    linkpost: '/tours-and-experiences/search?location=70c20023-4d88-40d1-9dad-f09eb916ac72'
  },
  // {
  //   id: 4,
  //   backgroundImageUrl: require('@assets/img/bg/muine.png').default,
  //   title: 'Quy Nhơn',
  //   linkpost: ''
  // },
  // {
  //   id: 5,
  //   backgroundImageUrl: require('@assets/img/bg/sapa.png').default,
  //   title: 'Sapa',
  //   linkpost: ''
  // },
  // {
  //   id: 6,
  //   backgroundImageUrl: require('@assets/img/bg/muine.png').default,
  //   title: 'Mũi Né',
  //   linkpost: ''
  // }
]

export const blogs = [
  {
    id: 1,
    title:
      'Khai trương khách sạn Vinpearl Luxury và Đài quan sát cao nhất Đông Nam Á',
    description:
      'Vinpearl đã khai thác đưa hơn 1,4 triệu lượt khách về tham quan du lịch các tỉnh, Thành là điểm nóng du lịch Việt Nam.',
    thumbnailUrl: require('@assets/img/bg/blog1.png').default,
    thumbnailAlt: 'Blog News Thumbnail Image',
    linkpost: ''
  },
  {
    id: 2,
    title: 'Vinpearl thu hút khách quốc tế với \'Free Walking Tour\'',
    description:
      'Vinpearl đã khai thác đưa hơn 1,4 triệu lượt khách về tham quan du lịch các tỉnh, Thành là điểm nóng du lịch Việt Nam.',
    thumbnailUrl: require('@assets/img/bg/blog2.png').default,
    thumbnailAlt: 'Blog News Thumbnail Image',
    linkpost: ''
  },
  {
    id: 3,
    title: 'Vinpearl thu hút khách quốc tế với \'Free Walking Tour\'',
    description:
      'Vinpearl đã khai thác đưa hơn 1,4 triệu lượt khách về tham quan du lịch các tỉnh, Thành là điểm nóng du lịch Việt Nam.',
    thumbnailUrl: require('@assets/img/bg/blog3.png').default,
    thumbnailAlt: 'Blog News Thumbnail Image',
    linkpost: ''
  },
  {
    id: 4,
    title: 'Vinpearl đạt 9 giải thưởng du lịch thế giới WTA 2019',
    description:
      'Tối 12-10, sự kiện \'Oscar ngành du lịch\' Châu Á & Châu Đại Dương 2019 đã được tổ chức tại Vinpearl Phú Quốc.',
    thumbnailUrl: require('@assets/img/bg/blog4.png').default,
    thumbnailAlt: 'Blog News Thumbnail Image',
    linkpost: ''
  },
  {
    id: 5,
    title: 'Vinpearl thu hút khách quốc tế với \'Free Walking Tour\'',
    description:
      'Vinpearl đã khai thác đưa hơn 1,4 triệu lượt khách về tham quan du lịch các tỉnh, Thành là điểm nóng du lịch Việt Nam.',
    thumbnailUrl: require('@assets/img/bg/blog5.png').default,
    thumbnailAlt: 'Blog News Thumbnail Image',
    linkpost: ''
  }
]

export const voucherbanners = [
  {
    id: 1,
    title: 'Khuyến mại',
    sale: '30',
    typeSale: '%',
    description:
      'Join for free and get our tailored newsletters full of hot travel deals.',
    linkText: 'Nhận khuyến mãi',
    link: '#',
    backgroundImageUrl: require('@assets/img/bg/bg-voucherbanner.png').default
  },
  {
    id: 2,
    title: 'Nhận ngay',
    sale: '400.000',
    typeSale: 'đ',
    description:
      'Join for free and get our tailored newsletters full of hot travel deals.',
    linkText: 'Tìm hiểu',
    link: '#',
    backgroundImageUrl: require('@assets/img/bg/bg-voucherbanner2.png').default
  }
]

export const specialVoucher = {
  id: 3,
  title: 'Ưu đãi đặc biệt',
  saleTo: '10%',
  description:
    'Join for free and get our tailored newsletters full of hot travel deals.',
  linkText: 'Xem ưu đãi',
  link: '#',
  backgroundImageUrl: require('@assets/img/bg/bg-voucher-banner-item3.png').default
}

export const vouchersInteresting = [
  {
    id: 1,
    saleTo: '35%',
    dateVoucher: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000',
    newPrice: '2.100.000',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher.png').default,
    backgroundImageAlt: 'Voucher hap dan',
    linkpost: ''
  },
  {
    id: 2,
    saleTo: '35%',
    dateVoucher: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000',
    newPrice: '2.100.000',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher2.png').default,
    backgroundImageAlt: 'Voucher hap dan',
    linkpost: ''
  },
  {
    id: 3,
    saleTo: '35%',
    dateVoucher: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000',
    newPrice: '2.100.000',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher3.png').default,
    backgroundImageAlt: 'Voucher hap dan',
    linkpost: ''
  }
]

export const vouchersAtVinpearl = [
  {
    id: 1,
    dateVoucher: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  },
  {
    id: 2,
    dateVoucher: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher2.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  },
  {
    id: 3,
    dateVoucher: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher3.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  },
  {
    id: 4,
    dateVoucher: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  }
]

export const orderInfo = {
  orderCode: '34789QL27819',
  transactionDate: '05:30 25/10/2019',
  contactInfo: {
    email: 'hainm@gmail.com',
    phone: '098 765 4321'
  },
  totalPrice: 9500000,
  currency: 'đ'
}

export const airport = [
  {
    id: 'PNR',
    name: 'Sân bay Pointe Noire ',
    cityId: 'PNR',
    cityName: 'Pointe Noire',
    countryId: 'CD',
    countryName: 'Công gô',
    isDomestic: false
  },
  {
    id: 'HAN',
    name: 'Sân bay Nội Bài',
    cityId: 'HAN',
    cityName: 'Hà Nội',
    countryId: 'VN',
    countryName: 'Việt Nam',
    isDomestic: true
  }
]

export const flightInfo = {
  flightNumber: 'BL - 730',
  startDate: moment('09/28/2019 18:00'),
  endDate: moment('09/28/2019 20:00'),
  startPoint: 'Hà Nội (HAN)',
  startAirport: 'Sân bay Nội Bài',
  endPoint: 'TP HCM (SGN)',
  endAirport: 'Sân bay Tân Sơn Nhất',
  duration: '2h10m',
  stops: 1,
  adult: 1,
  children: 1,
  infant: 1,
  priceAdult: 1000000,
  priceChild: 1000000,
  priceInfant: 1000000,
  totalPrice: 1000000
}

export const hotVouchers = [
  {
    id: 1,
    date: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  },
  {
    id: 2,
    date: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher2.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  },
  {
    id: 3,
    date: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher3.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  },
  {
    id: 4,
    date: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  }
]

export const hotTours = [
  {
    id: 1,
    date: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  },
  {
    id: 2,
    date: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher2.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  },
  {
    id: 3,
    date: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher3.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  },
  {
    id: 4,
    date: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  },
  {
    id: 5,
    date: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher2.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  },
  {
    id: 6,
    date: '01.08.2019 - 10.08.2019',
    title:
      'Time to Celebrate – Gói ưu đãi hấp dẫn từ Vinpearl Luxury nhân dịp 26 năm Vingroup',
    oldPrice: '3.100.000 VNĐ',
    newPrice: '2.100.000 VNĐ',
    backgroundImageUrl: require('@assets/img/bg/imgvoucher3.png').default,
    backgroundImageAlt: 'Voucher Vinpearl',
    linkpost: ''
  }
]
export const tourHot = [
  {
    id: 1,
    saleTo: '35%',
    title:
      'Vinpearl Resort & Golf Nam Hội An chỉ từ 3,825,000/đêm, miễn phí massage, đưa đón sân bay',
    dateTour: '3 Ngày 2 đêm',
    oldPrice: '3.100.000',
    newPrice: '2.100.000',
    currency: 'đ',
    backgroundImageUrl: require('@assets/img/bg/imgtourhot.png').default,
    backgroundImageAlt: '',
    url: ''
  },
  {
    id: 2,
    saleTo: '35%',
    title:
      'Vinpearl Resort & Golf Nam Hội An chỉ từ 3,825,000/đêm, miễn phí massage, đưa đón sân bay',
    dateTour: '3 Ngày 2 đêm',
    oldPrice: '3.100.000',
    newPrice: '2.100.000',
    currency: 'đ',
    backgroundImageUrl: require('@assets/img/bg/imgtourhot.png').default,
    backgroundImageAlt: '',
    url: ''
  },
  {
    id: 3,
    saleTo: '35%',
    title:
      'Vinpearl Resort & Golf Nam Hội An chỉ từ 3,825,000/đêm, miễn phí massage, đưa đón sân bay',
    dateTour: '3 Ngày 2 đêm',
    oldPrice: '3.100.000',
    newPrice: '2.100.000',
    currency: 'đ',
    backgroundImageUrl: require('@assets/img/bg/imgtourhot.png').default,
    backgroundImageAlt: '',
    url: ''
  },
  {
    id: 4,
    saleTo: '35%',
    title:
      'Vinpearl Resort & Golf Nam Hội An chỉ từ 3,825,000/đêm, miễn phí massage, đưa đón sân bay',
    dateTour: '3 Ngày 2 đêm',
    oldPrice: '3.100.000',
    newPrice: '2.100.000',
    currency: 'đ',
    backgroundImageUrl: require('@assets/img/bg/imgtourhot.png').default,
    backgroundImageAlt: '',
    url: ''
  }
]

export const infrastructure = [
  {
    icon: pathIconHotel  + 'like.svg',
    title: <FormattedMessage
      id="Hotel.Search.OtherInfo.PopularAmenities"
      defaultMessage='Tiện nghi phổ biển'
    />
    ,
    listDetail: [
      {
        icon: pathIconHotel  + 'car-rental.svg',
        title:
          <FormattedMessage
            id="Hotel.Search.OtherInfo.CarRental"
            defaultMessage='Cho thuê xe'
          />
      },
      {
        icon: pathIconHotel  + 'receptionist.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Reception"
          defaultMessage='Lễ tân (24/7)'
        />
      },
      {
        icon: pathIconHotel  + 'elevator.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Elevator"
          defaultMessage='Thang máy'
        />
      },
      {
        icon: pathIconHotel  + 'There-is-a-shuttle.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.ShuttleBusAvailable"
          defaultMessage='Có xe đưa đón'
        />
      },
      {
        icon: pathIconHotel  + '4-season-swimming-pool.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.4SeasonSwimmingPool"
          defaultMessage='Bể bơi 4 mùa'
        />
      },
      {
        icon: pathIconHotel  + 'near-shopping-center.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.NearCenter"
          defaultMessage='Gần TTTM'
        />
      },
      {
        icon: pathIconHotel  + 'gym.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.GYM"
          defaultMessage='Phòng GYM'
        />
      },
      {
        icon: pathIconHotel  + 'near-the-play-area.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.NearThePlayArea"
          defaultMessage='Gần khu vui chơi'
        />
      }
    ]
  },
  {
    icon: pathIconHotel  + 'earth.svg',
    title: <FormattedMessage
      id="Hotel.Search.OtherInfo.Language"
      defaultMessage='Ngôn ngữ sử dụng'
    />,
    listDetail: [
      {
        icon: pathIconHotel  + 'flag-vn.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Vietnamese"
          defaultMessage='Việt Nam'
        />
      },
      {
        icon: pathIconHotel  + 'flag-en.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.English"
          defaultMessage='Tiếng Anh'
        />
      },
      {
        icon: pathIconHotel  + 'flag-fr.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.French"
          defaultMessage='Tiếng Pháp'
        />
      },
      {
        icon: pathIconHotel  + 'flag-china.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Chinese"
          defaultMessage='Tiếng Trung'
        />
      }
    ]
  },
  {
    icon: pathIconHotel  + 'internet.svg',
    title: <FormattedMessage
      id="Hotel.Search.OtherInfo.InternetAccess"
      defaultMessage='Truy cập internet'
    />,
    listDetail: [
      {
        icon: pathIconHotel  + 'wifi-usb.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.PocketWifiRental"
          defaultMessage='Cho thuê wifi bỏ túi'
        />
      },
      {
        icon: pathIconHotel  + 'wifi-home.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.WifiInTheHouse"
          defaultMessage='Wifi trong nhà'
        />
      },
      {
        icon: pathIconHotel  + 'wifi-public.svg',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.PublicWifi"
          defaultMessage='Wifi công cộng'
        />
      }
    ]
  },
  {
    icon: pathIconHotel  + 'game.svg',
    title: <FormattedMessage
      id="Hotel.Search.OtherInfo.RelaxAndEntertain"
      defaultMessage='Thư giãn vui chơi giải trí'
    />,
    listDetail: [
      {
        icon: pathIconHotel  + 'Frame-4.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.4SeasonSwimmingPool"
          defaultMessage='Bể bơi 4 mùa'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-3.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.RelaxingSpa"
          defaultMessage='Thư giãn Spa'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-5.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Cinema"
          defaultMessage='Rạp chiếu phim'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-6.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Drinks"
          defaultMessage='Đồ uống'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-11.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Garden"
          defaultMessage='Sân vườn'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-21.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Casino"
          defaultMessage='Sòng bạc'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-27.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Bathtub"
          defaultMessage='Bồn tắm'
        />
      },
      {
        icon: pathIconHotel  + 'gym.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Gym"
          defaultMessage='Phòng thể dục'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-12.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Karaoke"
          defaultMessage='Karaoke'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-14.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.GroupTheaterRoom"
          defaultMessage='Phòng hát nhóm'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-13.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.ConcertHall"
          defaultMessage='Phòng hoà nhạc'
        />
      }
    ]
  },
  {
    icon: pathIconHotel  + 'food.svg',
    title: <FormattedMessage
      id="Hotel.Search.OtherInfo.Eating"
      defaultMessage='Ăn uống'
    />,
    listDetail: [
      {
        icon: pathIconHotel  + 'Frame-2.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.FreeBuffet"
          defaultMessage='Buffet miễn phí'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-37.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Restaurant"
          defaultMessage='Nhà hàng'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-6.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Bar"
          defaultMessage='Quầy bar'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-7.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Self-serviceBeerHouse"
          defaultMessage='Quán bia tự phục vụ'
        />
      }
    ]
  },
  {
    icon: pathIconHotel  + 'service.svg',
    title: <FormattedMessage
      id="Hotel.Search.OtherInfo.ServicesAndFacilities"
      defaultMessage='Dịch vụ và tiện nghi'
    />,
    listDetail: [
      {
        icon: pathIconHotel  + 'Frame-9.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.LaundryServices"
          defaultMessage='Dịch vụ giặt'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-36.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.IroningService"
          defaultMessage='Dịch vụ là ủi'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-17.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.BicycleRental"
          defaultMessage='Cho thuê xe đạp'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-18.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.CarForRent"
          defaultMessage='Cho thuê ô tô'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-1.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.PublicTransport"
          defaultMessage='Phương tiện công cộng'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-20.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.NearThePlayArea"
          defaultMessage='Gần khu vui chơi'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-16.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.MotorbikeRental"
          defaultMessage='Cho thuê xe máy'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-43.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.MoveToRoom"
          defaultMessage='Chuyển đồ tận phòng'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-46.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.DeliveryService"
          defaultMessage='Dịch vụ chuyển đồ'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-10.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.GiftGivingService"
          defaultMessage='Dịch vụ tặng quà'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-15.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.NearTheGasStation"
          defaultMessage='Gần cây xăng'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-8.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Mailing"
          defaultMessage='Gửi thư'
        />
      }
    ]
  },
  {
    icon: pathIconHotel  + 'children.svg',
    title: <FormattedMessage
      id="Hotel.Search.OtherInfo.ForKids"
      defaultMessage='Dành cho trẻ em'
    />,
    listDetail: [
      {
        icon: pathIconHotel  + 'Frame-29.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.PlayroomForChildren"
          defaultMessage='Phòng chơi cho trẻ'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-30.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.BabyFood"
          defaultMessage='Đồ ăn cho trẻ'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-28.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.BabysittingService"
          defaultMessage='Dịch vụ trông trẻ'
        />
      }
    ]
  },
  {
    icon: pathIconHotel  + 'car.svg',
    title: <FormattedMessage
      id="Hotel.Search.OtherInfo.TravelingAndMoving"
      defaultMessage='Đi lại và di chuyển'
    />,
    listDetail: [
      {
        icon: pathIconHotel  + 'Frame-48.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.PublicTransport"
          defaultMessage='Phương tiện công cộng'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-18.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Taxi"
          defaultMessage='Taxi (24/7)'
        />
      }
    ]
  },
  {
    icon: pathIconHotel  + 'bed.svg',
    title: <FormattedMessage
      id="Hotel.Search.OtherInfo.RoomUtilities"
      defaultMessage='Tiện ích trong phòng'
    />,
    listDetail: [
      {
        icon: pathIconHotel  + 'Frame-49.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.1DoubleBed"
          defaultMessage='1 giường đôi'
        />
      },
      {
        icon: pathIconHotel  + 'Frame.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Conditioner"
          defaultMessage='Điều hoà'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-22.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.SlippersInTheRoom"
          defaultMessage='Dép trong phòng'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-45.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Phone"
          defaultMessage='Điện thoại 24/7'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-32.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.1SingleBed"
          defaultMessage='1 giường đơn'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-34.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Mirror"
          defaultMessage='Gương'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-23.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Dryer"
          defaultMessage='Máy sấy'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-35.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Salon"
          defaultMessage='Salon'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-42.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Fridge"
          defaultMessage='Tủ lạnh'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-39.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.TV"
          defaultMessage='Tivi'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-31.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Desk"
          defaultMessage='Bàn làm việc'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-33.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Wardrobe"
          defaultMessage='Tủ đồ'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-38.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Bathrobe"
          defaultMessage='Áo choàng tắm'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-26.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Shower"
          defaultMessage='Vòi sen'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-40.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.TakeABath"
          defaultMessage='Tắm bồn'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-41.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Heaters"
          defaultMessage='Máy sưởi'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-44.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Tolets"
          defaultMessage='2 tolets'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-24.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.Towels"
          defaultMessage='4 khăn tắm'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-25.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.ShampooShowerGel"
          defaultMessage='Dầu gội - Sữa tắm'
        />
      },
      {
        icon: pathIconHotel  + 'Frame-50.png',
        title: <FormattedMessage
          id="Hotel.Search.OtherInfo.SatelliteCableTV"
          defaultMessage='Truyền hình cáp vệ tinh'
        />
      }
    ]
  }
]

export const voucher = {
  data: {
    // Test 1T
    id: '54fc0496-9f15-427f-a73e-d43f34b8cfaa',

    listRating: [
      {
        id: 1,
        avatar: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTLhTE0j-ePLaagDJNQkPnkafM0YH4WdXjVcr-aekMVcRevNUS4Iw&s" className="g-font-size-20 g-line-height-24 g-font-weight-500',
        name: 'Nguyễn Anh Ngọc',
        content:
          'Generate Lorem Ipsum placeholder text for use in your graphic, print and web layouts, and discover plugins for your favorite writing, design and blogging tools',
        description: 'Rất chuyên nghiệp, phục vụ tận tình và chu đáo',
        rating: 5
      },
      {
        id: 2,
        avatar: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfy4MFhYsGj_syaEJicDFqWr0Xxqc5g-5q4FJRxDsBGMJvOFJn&s',
        name: 'Phạm Thị Hà',
        content: 'Rất chuyên nghiệp, phục vụ tận tình và chu đáo',
        description: 'Rất chuyên nghiệp, phục vụ tận tình và chu đáo',
        rating: 5
      },
      {
        id: 3,
        avatar: 'data:image/jpeg;base64,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',
        name: 'Giáo Sư Điền',
        content: 'Rất chuyên nghiệp, phục vụ tận tình và chu đáo',
        description: 'Rất chuyên nghiệp',
        rating: 2
      }
    ],
    totalRating: 3,
    mediumRating: 3,
    rating: [0, 1, 0, 0, 2],  //rating_1 = 0,  rating_2 = 1, rating_3 = 0, rating_4 = 0, rating_5 = 2,

  },
  status: 200

}

export const bundleDetailResponse = {
  "data": {
    "bundleData": {
      "hotel": {
        "hotelId": "cbd21b5b-02fc-427a-9ea1-305459337779",
        "name": "Alpha Luxury Đà Nẵng",
        "types": [
          "Condotel"
        ],
        "star": 5.0000,
        "code": "VPLDNRV",
        "description": "<p>Kết hợp giữa lối thiết kế đương đại của kiến trúc Đông Dương thế kỷ 20 và phong cách cổ điển Pháp, tọa lạc tại bãi biển Non Nước thơ mộng, Vinpearl Luxury Đà Nẵng được vinh danh là “Khu nghỉ dưỡng biển hàng đầu Việt Nam” bởi World Travel Award vào năm 2017. Nhìn từ xa Vinpearl Premium Đà Nẵng như một bức tranh nàng tiên cá tựa lưng vào dãy núi Ngũ Hành và thả làn tóc ánh kim óng mượt xuống bờ cát. Khu khách sạn bao gồm 200 phòng nghỉ sang trọng tiện nghi đẳng cấp 5+ sao được thiết kế theo phong cách kiến trúc đương đại kết hợp với nét cổ điển quyến rũ của những khách sạn Đông Dương đầu thế kỷ XX. Tất cả các phòng đều có hướng nhìn ra biển và hồ bơi chính từ ban công của mỗi phòng bạn có thể thả lỏng người hít căng lồng ngực đón ánh bình minh và ngắm mặt trời mọc. Nội thất cũng như cách bố trí cảnh quan của khách sạn được thiết kế hợp lý sang trọng khiến bạn có cảm giác như đang ở giữa một thiên đường nghỉ dưỡng trong mơ. Các dịch vụ chăm sóc khách hàng của Vinpearl Premium Đà Nẵng từ đưa đón sân bay nghỉ dưỡng chăm sóc sức khỏe làm đẹp đến vui chơi giải trí ẩm thực… đều hoạt động theo đúng các tiêu chí sang trọng và riêng tư độc đáo và đẳng cấp tiện nghi và ấm áp.</p>",
        "address": "Số 7 Đường Trường Sa, Phường Hòa Hải, Quận Ngũ Hành Sơn, TP Đà Nẵng",
        "longtitude": "106.703385",
        "latitude": "10.765318",
        "review": 0.0000,
        "media": [
          {
            "order": 1,
            "url": "https://s3.ap-southeast-1.amazonaws.com/statics.stg.cloudhms.io/customer-files/37643830-3938-3831-2d37-6463662d6535/2020/01/2/100102-66306245-99c3-4e8f-94fb-12707d920237.jpg"
          },
          {
            "order": 1,
            "url": "https://s3.ap-southeast-1.amazonaws.com/statics.stg.cloudhms.io/customer-files/37643830-3938-3831-2d37-6463662d6535/2020/01/2/100105-dc2dd6df-71e3-4d08-b39b-11625f069ba4.jpg"
          },
          {
            "order": 1,
            "url": "https://s3.ap-southeast-1.amazonaws.com/statics.stg.cloudhms.io/customer-files/37643830-3938-3831-2d37-6463662d6535/2020/01/2/100111-523ad876-bbd7-495f-ae7c-df628c3e67ae.jpg"
          },
          {
            "order": 1,
            "url": "https://s3.ap-southeast-1.amazonaws.com/statics.stg.cloudhms.io/customer-files/37643830-3938-3831-2d37-6463662d6535/2020/01/2/100122-a36ae67b-4996-44c3-ab39-e3a7f1ecc295.jpg"
          }
        ],
        "amenity": [
          {
            "id": "00b227fd-63de-4e6c-afca-272db555abcc",
            "name": "Boating",
            "code": "BOAT",
            "description": "Boating",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/af0f3b71-2cf0-4bfe-b885-6570ebc5f9a1_Boating.png",
            "order": 0
          },
          {
            "id": "0bd2c58d-ee6d-4fd2-a082-42bb212962d4",
            "name": "balcony",
            "code": "balcony",
            "description": "balcony",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/c9087197-091d-42b1-8307-1608f1adfb31_Balcony.png",
            "order": 0
          },
          {
            "id": "0ec0ce0a-61f0-4bab-8c83-61c7e141d62b",
            "name": "Multilingual",
            "code": "MUL",
            "description": "Multilingual",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/8b153a61-60ca-4879-9107-7d62fdb014b1_Multilingual.png",
            "order": 0
          },
          {
            "id": "1df9cedc-6bfe-4565-b01e-1f420a325048",
            "name": "Outdoor Parking",
            "code": "OTA",
            "description": "Outdoor Parking",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/64a4933d-72de-46f5-92a9-7370c4b6ed0c_Outdoor_Parking.png",
            "order": 0
          },
          {
            "id": "238a7ba6-d2fe-4003-87a0-f12a8fd18d95",
            "name": "Conference Suite",
            "code": "CONS",
            "description": "Conference Suite",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/8dad0ac2-8d52-4c3c-b9ee-7a0e75e86292_Conference_Suite.png",
            "order": 0
          },
          {
            "id": "2b7fa638-a337-4304-80d7-1bf29d828c7e",
            "name": "Coffee Shop",
            "code": "CS",
            "type": "hotel-features",
            "icon": "https://statics.product.cloudhms.io/customer-files/37643830-6530-3838-2d33-3230392d3561/2020/03/6/072120-28891aca-52f5-4215-bf2d-7ae3765f46ed.jpg",
            "order": 0
          },
          {
            "id": "2dc12197-a9aa-4c8f-a6b6-e03d7f533e09",
            "name": "Exercise Gym",
            "code": "EXEG",
            "description": "Exercise Gym",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/4af60d95-e7bd-466e-92d2-ebaa379571f9_Exercise_Gym.png",
            "order": 0
          },
          {
            "id": "46324b73-b362-42be-bb51-4bd35420d51f",
            "name": "Beach",
            "code": "OHB",
            "description": "On the Beach",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/b85efc38-d323-4449-b40b-32bf72a3f642_Beach.png",
            "order": 0
          },
          {
            "id": "488815b4-fd35-498b-b89a-8f6dd85727fe",
            "name": "Heated Guest Rooms",
            "code": "HGR",
            "description": "Heated Guest Rooms",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/66725222-1a2f-4811-aadb-6c69bf697b20_Heated_Guest_Rooms.png",
            "order": 0
          },
          {
            "id": "49f946a2-c02e-40cb-a8f0-6f7e970505f0",
            "name": "Airline Desk",
            "code": "AIRD",
            "description": "Airline Desk",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/4607cbbb-8341-4a23-8041-a02d68303585_Airline_Desk.png",
            "order": 0
          },
          {
            "id": "55d781e0-242c-48c8-97b7-ba6500ab7f91",
            "name": "Pool",
            "code": "POO",
            "description": "Pool",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/1a252f67-c037-46bd-b40c-44ec395a216c_Pool.png",
            "order": 0
          },
          {
            "id": "5b7d7204-99bc-49eb-869b-06777d9a1a21",
            "name": "Courtyard",
            "code": "courtyard",
            "description": "Courtyard",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/e06a6ad5-ea83-4bf5-bdc0-b38c80b2913f_Courtyard.png",
            "order": 0
          },
          {
            "id": "5c715a54-1465-441e-8c6d-ca54e878acc7",
            "name": "Connecting Room",
            "code": "CO",
            "type": "hotel-features",
            "icon": "https://statics.product.cloudhms.io/customer-files/37643830-6530-3838-2d33-3230392d3561/2020/03/6/071439-a747a1e9-4ec5-43ab-9cac-3a2f7bc9aff4.jpg",
            "order": 0
          },
          {
            "id": "5e79e0ad-833c-4833-9bc5-e24b90418e20",
            "name": "24-Hour Room Service",
            "code": "24HRS",
            "description": "24-Hour Room Service",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/97f14fea-7df3-4992-b6ea-f235a81c0797_24-Hour_Room_Service.png",
            "order": 0
          },
          {
            "id": "5ed85905-a6f3-42e2-a94c-f7a865ffb96a",
            "name": "Health Club",
            "code": "HEC",
            "description": "Health Club",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/c4b88682-5f43-407f-be49-6973cbafca34_Health_Club.png",
            "order": 0
          },
          {
            "id": "6210ad9d-0863-40f1-9f06-0d42d91beeae",
            "name": "Laundry",
            "code": "LAV",
            "description": "Laundry/Valet",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/3f7ee39d-383e-4f30-b578-1b2eac1a1992_Laundry.png",
            "order": 0
          },
          {
            "id": "64a520e0-49c9-4609-b06e-48f913670e74",
            "name": "Copy Service",
            "code": "COPS",
            "description": "Copy Service",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/0ea8a2e9-a325-430f-b3b9-761984d464ce_Coffee_Shop.png",
            "order": 0
          },
          {
            "id": "6629e636-87f8-430e-a056-9b46d1ac067f",
            "name": "Large Suite",
            "code": "LAS",
            "description": "Large Suite",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/fdbb20a9-50c8-403e-97cb-1b6eb966c759_Big_room.png",
            "order": 0
          },
          {
            "id": "6b84b3cb-15a9-4a35-856b-eb5f295d46c8",
            "name": "Coffee Shop",
            "code": "COS",
            "description": "Coffee Shop",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/0ea8a2e9-a325-430f-b3b9-761984d464ce_Coffee_Shop.png",
            "order": 0
          },
          {
            "id": "6d8bb91d-30d2-4ef1-978d-d92df8d5d811",
            "name": "Handicap Facilities",
            "code": "HAF",
            "description": "Handicap Facilities",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/0dfcfbae-5307-487a-a4fe-4987528abb38_Handicap_Facilities.png",
            "order": 0
          },
          {
            "id": "6f8a127c-8eaa-4768-a859-f9e542ec090b",
            "name": "Beauty Salon",
            "code": "BES",
            "description": "Beauty Salon",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/c1b01852-9262-423d-8008-5da19ee3a564_Beauty_Salon.png",
            "order": 0
          },
          {
            "id": "7bad99b6-4e1a-48a7-b2b2-37b7f16ee8b0",
            "name": "Executive Level",
            "code": "EXEL",
            "description": "Executive Level",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/c5b3dd8a-0020-40ec-bf65-b693c4dc9b5f_Executive_Level.png",
            "order": 0
          },
          {
            "id": "7eb8dff0-1116-4c9c-a67c-6cebfe825fc2",
            "name": "Express Check In",
            "code": "ECIN",
            "description": "Express Check In",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/c41aaf6e-b00e-4f2f-bd74-b2674e81263c_Express_Check_In.png",
            "order": 0
          },
          {
            "id": "7ec02508-9c5a-45c4-acaf-30cad06edf56",
            "name": "Car Rental Desk",
            "code": "CRD",
            "description": "Car Rental Desk",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/2d7fb92f-3b68-4308-b2a8-775aecd5489a_Car_Rental_Desk.png",
            "order": 0
          },
          {
            "id": "7ec8e9f0-1cf3-4483-bbf7-cd461087fdc8",
            "name": "Playground",
            "code": "PAL",
            "description": "Playground",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/a530fbdc-828e-4e1d-8579-affc92137264_Playground.png",
            "order": 0
          },
          {
            "id": "8021b597-5f02-483d-81ae-30cd0f25b827",
            "name": "Business Center",
            "code": "BUSC",
            "description": "Business Center",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/011b301b-e39c-4622-98db-ec71092b1fb9_Casino.png",
            "order": 0
          },
          {
            "id": "8461aa9a-f6db-4256-89bf-dce0a24fd253",
            "name": "Currency Exchange",
            "code": "CURE",
            "description": "Currency Exchange",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/ea532a62-3115-40b5-8c58-45baf885b1ae_Poolside_Room.png",
            "order": 0
          },
          {
            "id": "8a7c2551-512f-4681-b784-8412dc093d2a",
            "name": "Outdoor Tennis",
            "code": "ODT",
            "description": "Outdoor Tennis",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/a8aa2752-27b3-49f8-99d7-ccd5460f23cd_Outdoor_Tennis.png",
            "order": 0
          },
          {
            "id": "9594d475-ca75-4463-b340-e381a173c3d0",
            "name": "Phone Service",
            "code": "PHS",
            "description": "Phone Service",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/6a05ae80-0944-4f0b-88ac-c28b914b3863_Florist.png",
            "order": 0
          },
          {
            "id": "9a4bcda6-8673-4ed5-982c-dc018cc99fe2",
            "name": "Meeting Facilities",
            "code": "MEF",
            "description": "Meeting Facilities",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/a085112d-1ef9-4083-921c-f56e71213b15_Meeting_utilities.png",
            "order": 0
          },
          {
            "id": "a3405b26-f7a6-4160-9edf-dc4ea34dee1f",
            "name": "Poolside Snackbar",
            "code": "POS",
            "description": "Poolside Snackbar",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/eb435bb8-939b-4fb4-be2d-d0755fd46607_Poolside_Snackbar.png",
            "order": 0
          },
          {
            "id": "a3962f67-d99c-41c9-972b-1361c03a228b",
            "name": "24-Hour Security",
            "code": "24HS",
            "description": "24-Hour Security",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/1925175a-7e91-4e1d-9686-867298414e62_24-Hour_Security.png",
            "order": 0
          },
          {
            "id": "aced1888-9db4-4ff2-ad85-5c1770125828",
            "name": "24-Hour Front Desk",
            "code": "24HRD",
            "description": "24-Hour Front Desk",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/84ecb8d1-283d-4f6e-9583-517410b4194e_24-Hour_Front_Desk.png",
            "order": 0
          },
          {
            "id": "b809bafa-316c-4427-8192-108727151d73",
            "name": "Bed and Breakfast",
            "code": "BABF",
            "description": "Bed and Breakfast",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/01e20151-4d71-45c7-a177-5f56f0f4d23c_Bed_and_Breakfast.png",
            "order": 0
          },
          {
            "id": "bbe40e25-879a-4bbb-8f81-5350a682a4e2",
            "name": "Maid Service",
            "code": "MAS",
            "description": "Maid Service",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/16df9041-ceea-445c-94c3-1e4eba79379d_Maid_Service.png",
            "order": 0
          },
          {
            "id": "bc3baf8f-feca-4317-afce-73da7f03724f",
            "name": "Executive Desk",
            "code": "EXED",
            "description": "Executive Desk",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/32dfd04f-38e2-47f3-823b-8c62c1e89cf8_Desk.png",
            "order": 0
          },
          {
            "id": "c45bb6e7-3a45-4b17-8160-2a29cabdb449",
            "name": "Express Check Out",
            "code": "ECOUT",
            "description": "Express Check Out",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/94fb302d-118a-4f9f-aa4c-66e9aa71aaf5_Express_Check_Out.png",
            "order": 0
          },
          {
            "id": "ca385564-d000-4568-a5ad-8b4767cf8ab0",
            "name": "Barber Shop",
            "code": "BARS",
            "description": "Barber Shop",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/fd77c2c8-1785-4f23-afe9-401b81678d9a_Barber_Shop.png",
            "order": 0
          },
          {
            "id": "d85c7ef7-9903-470c-9fac-9c1bd9000d41",
            "name": "Concierge Desk",
            "code": "COD",
            "description": "Concierge Desk",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/1b0534b7-5918-48de-bb1d-97ac28ed23b1_Projector.png",
            "order": 0
          },
          {
            "id": "dddadcbb-4ad1-4ad3-ab8e-7ea81f25822c",
            "name": "Dining",
            "code": "DIN",
            "description": "Dining&nbsp",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/b8f15c46-7146-45aa-8a94-7d0825d6d221_Dining.png",
            "order": 0
          },
          {
            "id": "ebc85dd0-1e24-4fb7-8d74-691408681888",
            "name": "Lounge",
            "code": "LO",
            "type": "hotel-features",
            "icon": "https://statics.product.cloudhms.io/customer-files/37643830-6530-3838-2d33-3230392d3561/2020/03/6/071308-42f4c5cd-daee-4481-9a25-aef636f3cbf9.jpg",
            "order": 0
          },
          {
            "id": "efc28ec2-63c9-4b93-9289-5093f7fc836f",
            "name": "Fax Services - Front Desk",
            "code": "FSFD",
            "description": "Fax Services - Front Desk",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/16e631c1-c0e5-4c5b-9209-491532adcaf8_Fax_Services_-_Front_Desk.png",
            "order": 0
          },
          {
            "id": "f1147dce-b0ac-4fab-9f83-26c2b5381f63",
            "name": "Bar",
            "code": "BAR",
            "description": "Bar",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/a10be4fe-0e57-4287-a262-5cdadd610935_Bar.png",
            "order": 0
          },
          {
            "id": "f29f3d0a-920e-4b51-b9b6-bf2a5a6ecf35",
            "name": "Free  Breakfast",
            "code": "FRB",
            "description": "Free  Breakfast",
            "type": "hotel-features",
            "icon": "https://aus-content.product.cloudhms.io/2019/4/3/01e20151-4d71-45c7-a177-5f56f0f4d23c_Bed_and_Breakfast.png",
            "order": 0
          }
        ],
        "roomTypes": []
      },
      "flight": {
        "departureFlights": {
          "fareOptions": [
            {
              "increasePrice": 0.0,
              "isCanHold": true,
              "class": "A",
              "groupClass": "Economy Super Lite",
              "fareOptionSession": "0",
              "flightSession": "0A_VN175HANDAD202006271400",
              "baggages": {
                "handBaggage": "10kg",
                "baggageAllowance": "23kg"
              }
            }
          ],
          "startPoint": "HAN",
          "endPoint": "DAD",
          "flightNumber": "VN175",
          "airlineCode": "VN",
          "startDate": "2020-06-27T14:00:00",
          "endDate": "2020-06-27T15:25:00",
          "stops": 0,
          "duration": 85,
          "listSegment": [
            {
              "airlineCode": "VN",
              "airlineName": "Vietnam Airlines",
              "airlineImage": "https://static.vinpearltravel.vn/flights/airlines/vn.gif",
              "startDate": "2020-06-27T14:00:00",
              "endDate": "2020-06-27T15:25:00",
              "startPoint": "HAN",
              "startPointName": "Sân bay Nội Bài",
              "startPointCityName": "Hà Nội",
              "endPoint": "DAD",
              "endPointName": "Sân bay Đà Nẵng",
              "endPointCityName": "Đà Nẵng",
              "flightNumber": "VN175",
              "plane": "321",
              "flightTime": 85,
              "class": "A"
            }
          ]
        },
        "returnFlights": {
          "fareOptions": [
            {
              "increasePrice": 0.0,
              "isCanHold": false,
              "groupClass": "Promo",
              "fareOptionSession": "147",
              "flightSession": "1A_Promo_VJ502DADHAN202006300730",
              "baggages": {
                "handBaggage": "7kg"
              }
            }
          ],
          "startPoint": "DAD",
          "endPoint": "HAN",
          "flightNumber": "VJ502",
          "airlineCode": "VJ",
          "startDate": "2020-06-30T07:30:00",
          "endDate": "2020-06-30T08:50:00",
          "stops": 0,
          "duration": 80,
          "listSegment": [
            {
              "airlineCode": "VJ",
              "airlineName": "Vietjet Air",
              "airlineImage": "https://static.vinpearltravel.vn/flights/airlines/vj.gif",
              "startDate": "2020-06-30T07:30:00",
              "endDate": "2020-06-30T08:50:00",
              "startPoint": "DAD",
              "startPointName": "Sân bay Đà Nẵng",
              "startPointCityName": "Đà Nẵng",
              "endPoint": "HAN",
              "endPointName": "Sân bay Nội Bài",
              "endPointCityName": "Hà Nội",
              "flightNumber": "VJ502",
              "plane": "321",
              "flightTime": 80,
              "class": "A"
            }
          ]
        },
        "itineraryType": 2,
        "departureDate": "27/06/2020",
        "returnDate": "30/06/2020",
        "adult": 1,
        "children": 1,
        "infant": 1,
        "isDomestic": true
      },
      "pricePerson": 0.0,
      "totalPrice": 0.0,
      "privateInfo": {
        "hotelPrice": 8750000.0,
        "flightDepartPrice": 655000.00,
        "flightReturnPrice": 601900.00
      }
    },
    "dataSession": "ac3d0bca24144c1db68efca53e3bc829",
    "startPointId": "063f209d-3a3f-4eb6-9248-fbe2ec3a3094",
    "startPointName": "Hà Nội",
    "endPointId": "d8ae859a-a7d9-42a0-a645-ffb05289ebe4",
    "endPointName": "Đà Nẵng",
    "departureDate": "2020-06-27T00:00:00",
    "returnDate": "2020-06-30T00:00:00",
    "adult": 1,
    "children": 1,
    "infant": 1,
    "room": 1
  }
}
